import { ScheduleTypes } from "../_enums/schedule-types.enum";

export type Bot = {
    id?: string | null | undefined;
    name?: string | undefined;
    status: BotStatus;
    statusDate: Date | null;

    totalAllocatedAmount: number;
    skipBudgetSafetyRules: boolean;
    bidPrice: number;
    maxPurchasedSymbolsCount: number;
    tradableBalance: number;
    isIntradayTradingAllowed: boolean;

    strategyType: number;
    strategyOptions?:
        | MartingaleStrategyOptions
        | TreasuresStrategyOptions
        | WizardStrategyOptions
        | CustomStrategyOptions
        | null
        | undefined;

    schedules: RunningSchedule[];

    allowedTradingSymbols: string[];
    allowedTradingSymbolGroups: string[];

    tradingSymbolsListId?: string | null | undefined;

    profit: number;
    availableBalance: number;
    purchasedSymbols: string[];
    brokerAccountId?: string | null | undefined;
    brokerAccountName?: string | null | undefined;

    isExpanded?: boolean | undefined;
};

export type MartingaleStrategyOptions = {
    id?: string | null | undefined;
    type: number;
    isDefault: boolean;
    rsiLowerLimit: number | null | undefined;
    rsiUpperLimit: number | null | undefined;
    emA200Limit: number | null | undefined;
    minProfitLimitForSell: number | null | undefined;
    buyBelowMA200: boolean | null | undefined;
    bids?: MartingaleStrategyBidInfo[] | null | undefined;
};

export type MartingaleStrategyBidInfo = {
    purchaseIndex: number;
    bidCoefficient: number;
    minPriceDropWithPrevBid: number;
};

export type TreasuresStrategyOptions = {
    id?: string | null | undefined;
    type: number;
    isDefault: boolean;
    symbolsPerRun?: number | null | undefined;
};

export type WizardStrategyOptions = {
    id?: string | null | undefined;
    type: number;
    isDefault: boolean;
    recoveryOrdersCount: number;
    recoveryOrdersPriceGap: number;
    entryOrderType: string;
    exitOrderType: string;

    runAfterMarketStart: boolean;
    buyAfterMarketStart: boolean;
    sellAfterMarketStart: boolean;

    runOnMarketMidday: boolean;
    buyOnMarketMidday: boolean;
    sellOnMarketMidday: boolean;

    runBeforeMarketClose: boolean;
    buyBeforeMarketClose: boolean;
    sellBeforeMarketClose: boolean;

    requiredEntryConditionsCount: number;
    entryConditions: Condition[];

    requiredRecoveryConditionsCount: number;
    recoveryConditions: Condition[];

    requiredSaleConditionsCount: number;
    saleConditions: Condition[];

    profitType: string;
    minProfitLimitForSell: number;
    stopLoss: number;
};

export type Condition = {
    isRequired: boolean;
    leftSide: ConditionSide;
    operator: string;
    rightSide: ConditionSide;
};

export type ConditionSide = {
    type: string | null | undefined;
    symbol?: string | null | undefined;
    dayBack?: number | null | undefined;
    field?: string | null | undefined;
    value?: number | null | undefined;
    lookbackPeriod?: number | null | undefined;
    stdDeviation?: number | null | undefined;
    fastPeriod?: number | null | undefined;
    slowPeriod?: number | null | undefined;
    signalPeriod?: number | null | undefined;
    kPeriod?: number | null | undefined;
    dPeriod?: number | null | undefined;
    rsiPeriod?: number | null | undefined;
    stochPeriod?: number | null | undefined;
    smoothPeriod?: number | null | undefined;
    initialFactor?: number | null | undefined;
    accelerationStep?: number | null | undefined;
    maxAccelerationFactor?: number | null | undefined;
    multiplier?: number | null | undefined;
    useHighLow?: boolean | null | undefined;
    maType?: string | null | undefined;
    tenkanPeriod?: number | null | undefined;
    kijunPeriod?: number | null | undefined;
    senkouBPeriod?: number | null | undefined;
    displacement?: number | null | undefined;
};

export type CustomStrategyOptions = {
    id?: string | null | undefined;
    isDefault: boolean;
    type: number;
    fields: CustomStrategyField[];
};

export type CustomStrategyField = {
    name: string;
    value: string;
    type: string;
};

export enum BotStatus {
    Draft = 0,
    WaitingForActivation = 1,
    Active = 2,
    Inactive = 3,
    Closing = 4,
}

export type RunningSchedule = {
    scheduleType: ScheduleTypes;
    buy: boolean;
    sell: boolean;
    value?: string | null | undefined;
};
